import { render, staticRenderFns } from "./GameTestingDailyGameV2.vue?vue&type=template&id=3ec7d35a&"
import script from "./GameTestingDailyGameV2.vue?vue&type=script&lang=js&"
export * from "./GameTestingDailyGameV2.vue?vue&type=script&lang=js&"
import style0 from "./GameTestingDailyGameV2.vue?vue&type=style&index=0&id=3ec7d35a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports